import { Controller } from '@hotwired/stimulus';
import { showModal, hideModal, initModal } from '../utils/modal';

export default class extends Controller {
  connect() {
    initModal();
    if (this.element.classList.contains('is-open')) {
      showModal(this.element.id);
    }
  }

  close() {
    hideModal(this.element.id);
  }
}
